import React from 'react';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';

import createInjectableComponent from '../../modules/createInjectableComponent';

import styles from './Landing.module.scss';

export const LandingIdentifier = Symbol('LANDING');
export type LandingProps = Record<string, never>;

const Landing = () => {
  const { assets, siteName } = useConfigStore((s) => s.config);
  const banner = assets.banner;

  return (
    <div className={styles.container}>
      <title>{siteName}</title>
      <header className={styles.header}>
        <h1 className={styles.logo}>{banner ? <img className={styles.banner} src={banner} alt={siteName} /> : siteName}</h1>
      </header>
      <main className={styles.hero}>
        <p>There is no login functionality available.</p>
      </main>
    </div>
  );
};

export default createInjectableComponent(LandingIdentifier, Landing);
